import React from "react";
import appendixAContent from "./appendixAcontent";
import "./style/App.css"; // Ensure CSS is imported

const AppendixA = () => {
  return (
    <div className="appendix-container">
      <h2 className="center-text">Appendix A</h2>
      <h4 className="center-text">To Individual and Entity Investor Qualification Statements</h4>
      <h4 className="center-bold-underline">Definition of “Investment” for purposes of the Investment Company Act</h4>
      <pre className="appendix-content">{appendixAContent}</pre>
    </div>
  );
};

export default AppendixA;
